import { render, staticRenderFns } from "./LotteryList.vue?vue&type=template&id=b7f5a8b6&scoped=true"
import script from "./LotteryList.vue?vue&type=script&lang=js"
export * from "./LotteryList.vue?vue&type=script&lang=js"
import style0 from "./LotteryList.vue?vue&type=style&index=0&id=b7f5a8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f5a8b6",
  null
  
)

export default component.exports